import { clientRoutes } from "./siteRoutes/clients";

export const siteRoutes = {
  ...clientRoutes,
};
